import { LogService } from 'library/ts/utilities/logger/LogService';
export class ConnectionMonitor {
    #utils;
    #capabilities;
    #callback;
    #onLine = navigator.onLine;
    #logger;
    #events = [
        'online',
        'offline'
    ];
    constructor(utils, capabilities, callback) {
        this.#utils = utils;
        this.#capabilities = capabilities;
        this.#callback = callback;
        this.#logger = LogService.create({ prefixes: ['SmartTag:', this.name + ':'] });
        for (let i = 0; i < this.#events.length; i++) {
            window.addEventListener(this.#events[i], this.#onConnectionChange);
        }
        if (this.#capabilities.isFirefox === true) {
            this.#logger.log('Firefox', 'start polling onLine status');
            setInterval(() => {
                if (this.#onLine !== navigator.onLine) {
                    this.#onLine = navigator.onLine;
                    if (this.#utils.Type.isFunction(this.#callback))
                        this.#callback(this.#onLine);
                }
            }, 200);
        }
    }
    get name() {
        return 'ConnectionMonitor';
    }
    get onLine() {
        return this.#onLine;
    }
    #onConnectionChange = (event) => {
        const eventTypeIsOnline = event?.type === 'online';
        if (this.#onLine !== eventTypeIsOnline) {
            this.#onLine = eventTypeIsOnline;
            if (this.#utils.Type.isFunction(this.#callback)) {
                this.#callback(this.#onLine);
            }
        }
    };
}
